import type { Product } from "@digital-garden/shared";
import { formatMoney } from "@digital-garden/shared";
import { ArrowUpRight, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../store";

export function ProductCard({ product }: { product: Product }) {
  const { add } = useCart();
  return <article className="product-card" style={{ "--accent": product.accent } as React.CSSProperties}>
    <div className="product-visual"><span>{product.shortName.slice(0, 2).toUpperCase()}</span><i /></div>
    <div className="product-meta"><span>{product.category}</span><span>{product.platform}</span></div>
    <h3>{product.name}</h3><p>{product.description}</p>
    <div className="tag-row">{product.tags.slice(0, 3).map((tag) => <span key={tag}>#{tag}</span>)}</div>
    <div className="product-footer"><div><strong>{formatMoney(product.priceUsd)}</strong><small>{formatMoney(product.priceBdt, "BDT")}</small></div><div className="card-actions"><button onClick={() => add(product)} aria-label={"Add " + product.name + " to cart"}><Plus size={17}/></button><Link to={"/market/" + product.slug} aria-label={"Open " + product.name}><ArrowUpRight size={17}/></Link></div></div>
  </article>;
}
